window.__WWAI__ = window.__WWAI__ || {};
    
// Environment + Mode Config
// Use metafield-based subscription in sandbox/local
window.__WWAI__.useMockSubscription = false;

// Options: "local" | "sandbox" | "prod"
window.__WWAI__.deployMode = "prod";

// Enables dev/debugger mode, values are dev, prod
window.__WWAI__.MODE = "prod";

// Controls Liquid-product rendering
window.__WWAI__.RENDER_WITH_LIQUID = true;

// Which connector to use for hydration
window.__WWAI__.CONNECTOR_TYPE = "shopify";

// Enable logging for grid height debugging
window.__WWAI__.heightEqualizeLogging = true;

// Currency Config
// Active currency from Shopify
window.__WWAI__.CURRENCY = Shopify.currency.active;

// Currency conversion factor
window.__WWAI__.CURRENCY_FACTOR = 0.01;

// Product mapping object
window.__WWAI__.JS_PRODUCT_MAPPING_OBJECT = {};

// Product group config
window.__WWAI__.WWAI_PRODUCT_GROUP_CONFIG = {
  "cholesterol_5_reasons_pdp_GNMiPr": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 25,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "subscription",
        "imageCarouselConfig": {
          "useCustomImages": true
        },
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "side-cart",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "dose",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "dose_liver_product_group": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "16oz",
        "defaultVariantOption1": "3 Pack",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "16oz | 2oz",
        "allOptions": {
          "option1": "3 Pack | 6 Pack | 24 Pack",
          "option2": "",
          "option3": ""
        }
      }
    }
  }
};

// Variant overrides
window.__WWAI__.WWAI_PRODUCT_VARIANT_OVERRIDES = {
  "cholesterol_5_reasons_pdp_GNMiPr": {
    "dose_liver_product_group": {
      "16oz": {
        "3 Pack": {
          "customMediaLabel": null,
          "redirectToMediaIndex": 0,
          "customLabelText": {
            "subscription": "($2.25 per Dose shot)",
            "one_time": "($3.75 per Dose shot)"
          }
        },
        "6 Pack": {
          "customMediaLabel": null,
          "redirectToMediaIndex": 6,
          "customLabelText": {
            "subscription": "($2.00 per Dose shot)",
            "one_time": "($3.33 per Dose shot)"
          }
        }
      },
      "2oz": {
        "24 Pack": {
          "customMediaLabel": null,
          "redirectToMediaIndex": 7,
          "customLabelText": {
            "subscription": "($2.88 per Dose shot)",
            "one_time": "($4.12 per Dose shot)"
          }
        }
      }
    }
  }
};

// Labeled images
window.__WWAI__.WWAI_LABELED_IMAGES = {};

// Action buttons
window.__WWAI__.WWAI_ACTION_BUTTONS = {
  "//div[@id=\"shopify-section-template--24874024698173__cholesterol_5_reasons_hero_banner_READYY\"]//div[1]/div[1]/div[1]/div[1]/a[1]": {
    "actionType": "scroll-to",
    "value": "shopify-section-template--24874024698173__cholesterol_5_reasons_pdp_GNMiPr"
  },
  "//div[@id=\"shopify-section-template--24874024698173__cholesterol_5_reasons_media_text_Nq4Chj\"]//div[1]/div[1]/div[1]/div[1]/a[1]": {
    "actionType": "scroll-to",
    "value": "shopify-section-template--24874024698173__cholesterol_5_reasons_pdp_GNMiPr"
  },
  "//div[@id=\"shopify-section-template--24874024698173__cholesterol_5_reasons_media_text_Nq4Chj\"]//div[1]/div[1]/div[2]/div[1]/a[1]": {
    "actionType": "scroll-to",
    "value": "shopify-section-template--24874024698173__cholesterol_5_reasons_pdp_GNMiPr"
  },
  "//div[@id=\"shopify-section-template--24874024698173__cholesterol_5_reasons_media_text_Nq4Chj\"]//div[1]/div[1]/div[4]/div[1]/a[1]": {
    "actionType": "scroll-to",
    "value": "shopify-section-template--24874024698173__cholesterol_5_reasons_pdp_GNMiPr"
  }
};
